import { type EmployeeLevel } from "@prisma/client";
import { type CompanySize } from "~/components/ui/CompanySizeSelector";
import { compact } from "~/lib/lodash";
import { arrayHasValues } from "~/lib/utils";
import { type MarketOrCompareInput } from "~/pages/api/get-market-data-stats";

export const generateEmployeesWithFiltersOptions = (params: {
  mergeAdvancedLevels: boolean;
  useTestData: boolean;
  useBenchmarkLevelsInShare?: boolean;
  marketOrCompare: MarketOrCompareInput;
  jobIds: number[];
  levels: EmployeeLevel[];
  benchmarkLevelsRange: { min: number; max: number };
  options: { canAccessFiguresAiV2: boolean };
}) => {
  const { mergeAdvancedLevels, useTestData, useBenchmarkLevelsInShare, marketOrCompare, jobIds, levels, options } =
    params;

  const industriesIds = compact([marketOrCompare.industryId, ...marketOrCompare.industriesIds]);

  return {
    mergeAdvancedLevels,
    useTestData,
    useBenchmarkLevelsInShare,
    jobIds,
    levels,
    benchmarkLevelsRange: params.benchmarkLevelsRange,
    locationIds: marketOrCompare.locationsIds,
    ...(options.canAccessFiguresAiV2
      ? { headcount: marketOrCompare.headcount }
      : { companySize: marketOrCompare.size as CompanySize }),
    ...(marketOrCompare.fundingRounds.length && { fundingRounds: marketOrCompare.fundingRounds }),
    ...(arrayHasValues(marketOrCompare.labelsIds) && {
      labels: { tagIds: marketOrCompare.labelsIds },
    }),
    ...(arrayHasValues(industriesIds) && {
      industries: { tagIds: industriesIds },
    }),
    ...(arrayHasValues(marketOrCompare.industriesIds) && {
      industries: { tagIds: marketOrCompare.industriesIds },
    }),
  };
};
